<template>
  <div class="multi-enum-wrap">
    <div class="tip" v-if="tipRule && tipRule.length">
      <span v-for="(tip, idx) in tipRule" :key="idx" v-html="tip"></span>
    </div>
    <div class="material-list">
      <div class="material-row" v-for="(row, idx) in rows" :key="idx">
        <el-select v-model="row.value" placeholder="请选择" filterable clearable style="width: 160px" @change="onMaterialChange(idx)">
          <el-option v-for="opt in filteredOptions(idx)" :key="opt.value" :label="opt.displayName" :value="opt.value"> </el-option>
        </el-select>
        <el-input v-model="row.percent" placeholder="请输入" style="width: 100px; margin: 0 8px" @input="onPercentChange(idx)">
          <span style="margin: 0 4px;" slot="suffix">%</span>
        </el-input>
        <el-button type="text" @click="removeRow(idx)">删除</el-button>
      </div>
    </div>
    <el-button v-if="rows.length < maxItems" type="text" class="add-btn" @click="addRow"> +添加材质 </el-button>
  </div>
</template>

<script>
import storeMixins from '../store-mixins';

export default {
  mixins: [storeMixins],
  props: ['props', 'value', 'isMultiComlexItem', 'emitUpdate', 'tipRule'],
  data() {
    return {
      rows: [],
    };
  },
  computed: {
    key() {
      return this.props?.name;
    },
    _value() {
      return this.isMultiComlexItem || this.emitUpdate ? this.value : this.alibabaForm[this.key];
    },
    maxItems() {
      return 7;
    },
  },
  watch: {
    _value: {
      handler(v) {
        this.parseValue(v);
      },
      immediate: true,
    },
  },
  methods: {
    parseValue(val) {
      if (!val) {
        this.rows = [];
        return;
      }
      try {
        let parsed;
        if (typeof val === 'string') {
          parsed = JSON.parse(val);
        } else if (Array.isArray(val)) {
          parsed = val;
        } else {
          this.rows = [];
          return;
        }
        if (!Array.isArray(parsed)) {
          this.rows = [];
          return;
        }
        this.rows = parsed.map(item => {
          const { value, text } = item;
          let percent = '';
          if (text) {
            const match = text.match(/^(.*?):(\d+\.?\d*)%$/);
            if (match) {
              percent = match[2];
            }
          }
          return { value, percent };
        });
      } catch (e) {
        console.error('MultiEnum parseValue error:', e);
        this.rows = [];
      }
    },
    formatValue() {
      return JSON.stringify(
        this.rows
          .filter(r => r.value)
          .map(r => {
            const opt = this.options.find(o => o.value === r.value);
            const displayName = opt ? opt.displayName : '';
            const text = r.percent ? `${displayName}:${r.percent}%` : displayName;
            return { value: r.value, text };
          })
      );
    },
    emitChange() {
      const formatted = this.formatValue();
      console.log(formatted, '---formatted---')
      if (this.isMultiComlexItem || this.emitUpdate) {
        this.$emit('change', { [this.key]: formatted });
      } else {
        this.updateAlibabaForm({ [this.key]: formatted });
      }
    },
    addRow() {
      if (this.rows.length >= this.maxItems) return;
      this.rows.push({ value: '', percent: '' });
      this.emitChange();
    },
    removeRow(idx) {
      this.rows.splice(idx, 1);
      this.emitChange();
    },
    onMaterialChange(idx) {
      this.emitChange();
    },
    onPercentChange(idx) {
      this.emitChange();
    },
    filteredOptions(currentIdx) {
      const selectedValues = this.rows.map((r, i) => (i !== currentIdx && r.value ? r.value : null)).filter(Boolean);
      return this.options.filter(opt => !selectedValues.includes(opt.value));
    },
  },
};
</script>

<style lang="scss" scoped>
.multi-enum-wrap {
  width: 100%;
  .tip {
    color: #909399;
    font-size: 12px;
    margin-bottom: 8px;
    line-height: 1.5;
  }
  .material-list {
    .material-row {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
    }
  }
  .add-btn {
    padding: 0;
    font-size: 12px;
  }
  .total-info {
    color: #e6a23c;
    font-size: 12px;
    margin-top: 8px;
  }
}
</style>
